'use client';

import type { ElementType, ReactNode } from 'react';
import Link from 'next/link';

import { cn } from '@/lib/utils';

interface NavItemProps {
  href: string;
  icon: ElementType;
  label: string;
  active?: boolean;
  badge?: ReactNode;
  onClick?: () => void;
  collapsed?: boolean;
}

export function NavItem({ href, icon: Icon, label, active = false, badge, onClick, collapsed = false }: NavItemProps) {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={cn(
        'flex h-11 items-center gap-3 rounded-md px-3 text-body text-text-2 outline-none transition-all duration-motion-sm ease-calm focus-visible:ring-2 focus-visible:ring-ring-1',
        active ? 'bg-surface-2 text-text-1 border border-transparent' : 'hover:bg-surface-2 hover:text-text-1 border border-transparent',
        collapsed && 'w-11 justify-center px-0'
      )}
      aria-current={active ? 'page' : undefined}
      title={collapsed ? label : undefined}
    >
      <Icon className="h-4 w-4" />
      {!collapsed ? <span className="truncate">{label}</span> : null}
      {!collapsed && badge ? <span className="ml-auto">{badge}</span> : null}
    </Link>
  );
}
